// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.carousel-slide[data-v-6f708e6d] {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    overflow: auto
}
`, "",{"version":3,"sources":["webpack://./resources/js/lego/components/carousels/CarouselSlide.vue"],"names":[],"mappings":";AAQA;IAAA,kBAAA;IAAA,MAAA;IAAA,SAAA;IAAA,OAAA;IAAA,QAAA;IAAA,aAAA;IAAA,sBAAA;IAAA,mBAAA;IAAA,uBAAA;IAAA;AAAA","sourcesContent":["<template>\n  <div class=\"carousel-slide\">\n    <slot />\n  </div>\n</template>\n\n<style scoped lang=\"postcss\">\n.carousel-slide {\n  @apply absolute top-0 bottom-0 left-0 right-0 flex flex-col justify-center items-center overflow-auto;\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
